import { useState } from 'react';

import styled from 'styled-components';

import { TotadminPermission } from 'data/__generated__';

import { PAGES } from 'constants/pages';

import { Header, HeaderTitle } from 'components/Header';
import { PageTitle } from 'components/PageTitle';
import { TotemPrimaryButton } from 'components/TotemPrimaryButton';

import { PermissionGroupsList } from './components/PermissionGroupsList';
import { PermissionGroupPopup } from './Popups/PermissionGroupPopup';

export const PermissionGroups = () => {
    const [isCreatePopupOpen, setIsCreatePopupOpen] = useState<boolean>(false);

    return (
        <Container>
            <Header>
                <HeaderTitle>
                    <PageTitle page={PAGES.permissionGroups} />
                </HeaderTitle>
                <TotemPrimaryButton
                    onClick={() => setIsCreatePopupOpen(true)}
                    data-test="permission-group-create"
                    requiredPermissions={[TotadminPermission.PermissionsManage]}
                >
                    Créer un groupe
                </TotemPrimaryButton>
            </Header>
            <PermissionGroupsList />
            <PermissionGroupPopup isOpen={isCreatePopupOpen} setIsOpen={setIsCreatePopupOpen} />
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 100%;
    background-color: ${({ theme }) => theme.backgroundColor};
`;
